import axios from "axios";
import { environment } from "../../../environments/environment";

export function getTypeSeries(
  filters,
  page = 0,
  pageSize = 10,
  search = "",
  sortingOrder
) {
  let filtersJson = [];
  filters.forEach((filter) => {
    filtersJson.push({
      columnName: filter.columnName,
      value: filter.value,
    });
  });
  if (filtersJson)
    filtersJson.push({
      columnName: "accountId",
      value: [parseInt(localStorage.getItem("u_account_id"))],
    });

  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let extraFilter = {
    companyIds: companies.map((e) => e.id),
  };
  let bodyFilter = {
    filters: filtersJson,
    extraFilter: extraFilter,
  };
  return axios.post(
    `${environment.getTypeSeries}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}`,
    bodyFilter,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getTypeSeriesConfigurationInfo(aircraftId) {
  return axios.get(
    environment.getTypeSeriesConfigurationInfo + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}

export function calculateActualAircaftsByType(typeSeriesId) {
  let filterArray = [
    {
      columnName: "id",
      value: [typeSeriesId],
    },
    {
      columnName: "accountId",
      value: [parseInt(localStorage.getItem("u_account_id"))],
    },
  ];

  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let extraFilter = {
    companyIds: companies.map((e) => e.id),
  };
  let bodyFilter = {
    filters: filterArray,
    extraFilter: extraFilter,
  };
  return axios.post(
    `${environment.getTypeSeries}?page=${0}&pageSize=${10}`,
    bodyFilter,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function createType(body) {
  let accountId = parseInt(localStorage.getItem("u_account_id"));
  return axios.request({
    method: body.id === null ? "POST" : "PUT",
    url: environment.createType,
    data:
      body.id === null
        ? null
        : isNaN(accountId)
        ? body
        : { ...body, accountId },
  });
}

export function removeType(aircraftId) {
  return axios.delete(`${environment.deleteType}?aircraftId=${aircraftId}`);
}

export function getAircraftList(
  page = 0,
  pageSize = 10,
  aircraftId,
  sortingOrder
) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push({
    columnName: "companyId",
    value: companyIds,
  });
  return axios.post(
    `${environment.getAircraftList}?page=${page}&pageSize=${pageSize}&aircraftId=${aircraftId}&orderBy=${sortingOrder}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getAircraftConfigurationInfo(aircraftId) {
  return axios.get(
    environment.getAircrafConfigurationInfo + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}
export function updateAircraft(body) {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  return axios.request({
    method: "PUT",
    url: environment.createAircraft,
    data: body,
  });
}
export function createAircraft(body) {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  return axios.request({
    method: "POST",
    url: environment.createAircraft,
    data:
      body.id === null
        ? null
        : isNaN(companyId)
        ? body
        : { ...body, companyId },
  });
}

export function getBalanceAircraft(aircraftId) {
  return axios.get(
    environment.getBalanceByAircraft + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}

export function getWarrantyAircraft(aircraftId) {
  return axios.get(
    environment.getWarrantyAircraft + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}

export function getDeliveryInformation(aircraftId) {
  return axios.get(
    environment.getDeliveryInformationAircraft + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}

export function getLastFlightInformation(aircraftId) {
  return axios.get(
    environment.getLastFlightInformation + "?aircraftId=" + aircraftId,
    { hideLoader: true }
  );
}
export function removeAircraft(aircraftId) {
  return axios.delete(`${environment.deleteAircraft}?aircraftId=${aircraftId}`);
}
export function updateAircraftWarranty(body) {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  return axios.request({
    method: "PUT",
    url: environment.updateWarranty,
    data:
      body.id === null
        ? null
        : isNaN(companyId)
        ? body
        : { ...body, companyId },
  });
}

export function updateAircraftBalance(body) {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  return axios.request({
    method: "PUT",
    url: environment.updateBalance,
    data:
      body.id === null
        ? null
        : isNaN(companyId)
        ? body
        : { ...body, companyId },
  });
}

export function updateDeliveryInformation(body) {
  let companyId = parseInt(localStorage.getItem("u_company_id"));
  return axios.request({
    method: "PUT",
    url: environment.updateDeliveryInformation,
    data:
      body.id === null
        ? null
        : isNaN(companyId)
        ? body
        : { ...body, companyId },
  });
}
